import { motion } from "framer-motion";
import type { ReactNode } from "react";
import { fadeLeft, viewport } from "../../lib/motion";

export function Container({ children, className = "" }: { children: ReactNode; className?: string }) {
  return <div className={`mx-auto w-full max-w-content px-4 sm:px-6 lg:px-8 ${className}`}>{children}</div>;
}

export function Section({
  id,
  children,
  className = "",
  labelledBy,
  muted = false,
}: {
  id?: string;
  children: ReactNode;
  className?: string;
  labelledBy?: string;
  muted?: boolean;
}) {
  return (
    <section
      id={id}
      aria-labelledby={labelledBy}
      className={`py-16 md:py-24 ${muted ? "bx-section-muted" : ""} ${className}`}
    >
      {children}
    </section>
  );
}

export function SectionHeading({ id, title, subtitle }: { id: string; title: string; subtitle?: string }) {
  return (
    <motion.header
      className="mb-10 max-w-2xl"
      variants={fadeLeft}
      initial="hidden"
      whileInView="visible"
      viewport={viewport}
    >
      <h2 id={id} className="text-3xl font-bold tracking-tight md:text-4xl" style={{ color: "var(--color-text)" }}>
        {title}
      </h2>
      {subtitle && <p className="bx-text-muted mt-3 text-lg">{subtitle}</p>}
    </motion.header>
  );
}
